import { EDistributionBand, EEvolutionWindow, ERiskAlertSeverity, ERiskBand } from '../types';

export const RISK_BAND_RANGES: Record<ERiskBand, { min: number; max: number }> = {
  [ERiskBand.HIGH]: { min: 0, max: 400 },
  [ERiskBand.MEDIUM]: { min: 401, max: 700 },
  [ERiskBand.LOW]: { min: 701, max: 1000 },
};

export const MAX_SCORE = 1000;

export const SCORE_TEXT_COLOR_BY_BAND: Record<ERiskBand, string> = {
  [ERiskBand.HIGH]: '#C0392B',
  [ERiskBand.MEDIUM]: '#EFB103',
  [ERiskBand.LOW]: '#008561',
};

export const DISTRIBUTION_DOT_COLOR: Record<EDistributionBand, string> = {
  [EDistributionBand.LOW]: '#008561',
  [EDistributionBand.MEDIUM]: '#EFB103',
  [EDistributionBand.HIGH]: '#C0392B',
  [EDistributionBand.UNSCORED]: '#A4A5A7',
  [EDistributionBand.NOT_QUERIED]: '#A4A5A7',
};

export const BENCHMARK_BAR_COLOR = '#234F68';

export const EVOLUTION_SERIES_COLORS = {
  averageScore: '#008561',
  highRiskAverageScore: '#C0392B',
  exposure: '#234F68',
};

export const EVOLUTION_WINDOWS: Array<EEvolutionWindow> = [
  EEvolutionWindow.DAYS_30,
  EEvolutionWindow.DAYS_15,
  EEvolutionWindow.DAYS_7,
];

export const ALERT_SEVERITY_COLOR: Record<ERiskAlertSeverity, string> = {
  [ERiskAlertSeverity.CRITICAL]: '#C0392B',
  [ERiskAlertSeverity.WARNING]: '#8F6A02',
  [ERiskAlertSeverity.INFO]: '#d2d2d3',
};

export const ALERT_SEVERITY_ORDER: Record<ERiskAlertSeverity, number> = {
  [ERiskAlertSeverity.CRITICAL]: 0,
  [ERiskAlertSeverity.WARNING]: 1,
  [ERiskAlertSeverity.INFO]: 2,
};

export const TOP_RISK_PARTNERS_LIMIT = 10;

export const PARTNERS_MODAL_PAGE_SIZE = 150;

export const PARTNERS_REQUEST_MAX_PAGE_SIZE = 500;

export const GAUGE_GEOMETRY = {
  width: 258,
  height: 160,
  centerX: 129,
  centerY: 119.692,
  pointerLength: 71.5,
  startAngle: 210,
  sweepAngle: 240,
  outerRadius: 89.308,
  innerRadius: 63.508,
};
